module.exports = __webpack_public_path__ + "static/media/18.ecc3693d.jpeg";